module.exports = __webpack_public_path__ + "img/placeholder.3e950354.jpeg";